<template>
	<v-card>
		<v-card-title>
			<span class="headline">انتخاب وضعیت</span>
			<v-spacer />
			<v-btn @click="$emit('close')" icon>
				<v-icon>mdi-close</v-icon>
			</v-btn>
		</v-card-title>
		<v-card-text>
			<div class="text-center success--text" v-if="loading2">
				در حال دریافت اطلاعات ...
			</div>
			<v-item-group v-else v-model="selection" class="d-flex justify-space-between mb-3" multiple>
				<v-row>
					<v-col cols="12" md="6" v-for="(item, index) in items" :key="index">
						<v-item :value="item.id" class="mx-1">
							<template v-slot="{ active, toggle }">
								<v-sheet :class="active && 'status-selector-item--active'" :color="active ? 'secondary' : '#ddd'" class="status-selector-item" @click="toggle">
									<v-icon v-if="active" color="#fff" class="ml-2">mdi-check-circle</v-icon>
									{{ item.title }}
								</v-sheet>
							</template>
						</v-item>
					</v-col>
				</v-row>
			</v-item-group>
		</v-card-text>
		<v-divider></v-divider>

		<v-card-actions>
			<v-spacer />
			<v-btn @click="$emit('close')">
				بستن
			</v-btn>
			<v-btn color="blue" dark :loading="loading" @click="save">
				ذخیره
			</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
	import { call, get } from 'vuex-pathify'
	import toast from '@/util/toast'

	export default {
		name: 'StatusSelectorForDashboard',
		props: {
			type: {
				type: String
			}
		},
		data: () => ({
			items: [],
			loading: false,
			loading2: false,
			selection: []
		}),
		mounted() {
			this.loadStatuses()
			this.setSelection()
		},
		computed: {
			...get('appSettings', [
				'settings'
			])
		},
		watch: {
			deep: true,
			settings(val) {
				setSelection(val)
			},
		},
		methods: {
			fetchLoanRequestStatus: call('loanRequestStatus/fetch'),
			syncSettings: call('appSettings/sync'),
			loadStatuses(force = false) {
				this.loading2 = true
				this.fetchLoanRequestStatus({ force: force }).then(items => {
					this.items = items
					this.loading2 = false
				})
			},
			save() {
				if (!this.selection?.length) {
					toast.error('هیچ آیتمی انتخاب نشده است.')
					return
				}
				let data = _.cloneDeep(this.settings)

				if (this.type === 'depositChargeDueDate')
					data.depositChargeDueDateStatuses = this.selection

				if (this.type === 'sponsoreDueDate')
					data.sponsoreDueDateStatuses = this.selection

				this.loading = true
				this.syncSettings(data).then(x => {
					this.loading = false
					this.$emit('close')
				}).catch(err => {
					this.loading = false
					toast.error(err.message)
				})
			},
			setSelection() {
				switch (this.type) {
					case 'depositChargeDueDate':
						this.selection = this.settings.depositChargeDueDateStatuses || []
						break
					case 'sponsoreDueDate':
						this.selection = this.settings.sponsoreDueDateStatuses || []
						break
					default:
						break
				}
			}
		}
	}
</script>

<style scoped>
	.status-selector-item {
		height: 50px;
		padding: 10px;
		border-radius: 20px;
		cursor: pointer;
		color: grey;
		display: flex;
		align-items: center;
	}

	.status-selector-item--active {
		color: white
	}
</style>